import { http, httpNoTimeout } from "./http"

export const fetchAvailablePrograms = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  try {
    const res = (await http
      .get("tv-programs/available-programs", { searchParams })
      .json()) as { data: Array<ProgramOption> }
    return res?.data
  } catch {
    return [] as Array<ProgramOption>
  }
}

export interface ValidateProgramNamesPayload {
  programMediaFieldId: string
  lineItems: Array<{
    id?: string
    channel?: string
    broadcastDates?: string[]
    program?: string
    programStartTime?: string
  }>
}

export type ProgramOption =
  | {
      programName: string
      programStartTime: string
      programEndTime: string
    }
  | string

export const validateProgramNames = async (
  body: ValidateProgramNamesPayload,
) => {
  const res = await httpNoTimeout
    .post("tv-programs/validate", { json: body })
    .json()
  return res
}
